module.exports = __webpack_public_path__ + "fa-regular-400.c5d109be8edd3de0f60e.svg";


//////////////////
// WEBPACK FOOTER
// F:/node/angular/complejidadesFrontend/~/@fortawesome/fontawesome-free/webfonts/fa-regular-400.svg
// module id = ../../../../@fortawesome/fontawesome-free/webfonts/fa-regular-400.svg
// module chunks = 2